import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useLazyQuery } from '@apollo/client';

import { CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import * as Q from '../../../../../constants/graphqlQueries';

import './AdminDetails.css';
import colors from '../../../../../constants/colors';

const useStyles = makeStyles(() => ({
  tableHead: {
    background: '#f3f3f3 !important'
  },
  circular: {
    position: 'absolute',
    left: '50%',
    color: colors.blue
  }
}));

const AdminDetails = ({ rowData }) => {
  const classes = useStyles('');
  const [agentsPopulation, setAgentsPopulation] = useState([]);

  const [getAgenstById, { data: agentsData, loading }] = useLazyQuery(Q.ADMIN_MANAGMENT_SEARCH_AGENTS);

  useEffect(() => {
    if(Object.keys(rowData)) {
      getAgenstById({variables: { SupervisorId: rowData.EmployeeId }})
    }
  }, [rowData]);
  useEffect(() => {
    if(agentsData) {
      setAgentsPopulation(agentsData.searchEmployeesBySupervisorId);
    }
    return function cleanUp () { setAgentsPopulation([]) }
  }, [agentsData]);

  return loading ? <CircularProgress className={classes.circular} /> : (
    <div className='admin__details__wrapper'>
      <TableContainer component={Paper}>
      <Table aria-label='simple table'>
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell>Employee Name</TableCell>
            <TableCell>Oracle ID</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Site</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {agentsPopulation.length ? (agentsPopulation.map(agent => (
            <TableRow key={agent.EmployeeId}>
              <TableCell component='th'>{`${agent.person.FirstName} ${agent.person.LastName}`}</TableCell>
              <TableCell>{agent.EmployeeId}</TableCell>
              <TableCell>{agent.JobRole}</TableCell>
              <TableCell>{agent.SiteDescription}</TableCell>
            </TableRow>
            )
          )) : null
          }
        </TableBody>
      </Table>
      </TableContainer>
    </div>
  );
};

AdminDetails.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  rowData: PropTypes.object.isRequired,
};

export default AdminDetails;
